import { useTranslation } from "react-i18next";
import CookiesConsent from "./CookiesConsent/CookiesConsent";
import Footer from "./Footer/Footer";
import { navItems } from "./navigation-data";
import Seo from "./Seo";
import TopMenu from "./TopMenu/TopMenu";

type PageProps = {
  isFrontPage?: boolean;
  children: React.ReactNode;
  title: string;
  description: string;
};
const Page = ({ isFrontPage = false, children, title, description }: PageProps) => {
  const { i18n } = useTranslation();

  return (
    <>
      <Seo
        title={title}
        description={description}
        lang={i18n.language}
        meta={[]}
        reviewData={{
          ratingValue: 4.9,
          ratingCount: 76,
          reviewCount: 76,
        }}
        businessName="Lanchas La Gaviota"
        businessUrl="https://lanchaslagaviota.com"
        address={{
          streetAddress: "Moll Nou, Bajo 1",
          addressLocality: "Port de Pollença",
          addressRegion: "Islas Baleares",
          postalCode: "07470",
          addressCountry: "Spain",
        }}
      />

      <CookiesConsent />

      <TopMenu navItems={navItems} useScroll={isFrontPage} />

      {children}

      <Footer navItems={navItems} />
    </>
  );
};

export default Page;
